import { useEffect } from "react";
import { useVehicle } from "../../contexts/VehicleContext";
import { useCheckFitmentMutation } from "../Api/fitmentApi";

export const usePartFitment = (partId: string) => {
  const { vehicle } = useVehicle();
  const [checkFitment, { data, isLoading, isError }] =
    useCheckFitmentMutation();

  useEffect(() => {
    if (!vehicle || !partId) return;

    checkFitment({
      partId,
      vehicle,
    });
  }, [vehicle, partId, checkFitment]);

  return {
    vehicle,
    fits: data?.fits,
    loading: isLoading,
    error: isError,
  };
};
